import { Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { guid } from '@datorama/akita';
import { AkitaNgFormsManager } from '@datorama/akita-ng-forms-manager';
import { FormController } from '@lycoris-nubila/ngx-lycoris';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';

import { OrganizationPropertyName } from 'organization/model/organization-property-name';
import { AppService } from 'presentation/app.service';
import { UserApplicationPort } from 'user/port/user-application.port';

@Injectable()
export class SidebarAddExistingCoacheeController extends FormController<any> {
	public organizationsId$: Observable<string[]>;
	public coacheesWithoutCoach$: Observable<SelectItem[]>;

	constructor(
		private _fb: FormBuilder,
		formsManager: AkitaNgFormsManager,
		private _appService: AppService,
		private _translateService: TranslateService,
		private _userApplicationPort: UserApplicationPort
	) {
		super(
			formsManager,
			`sidebar-add-exisiting-coachee-${guid()}`,
			_fb.group({
				coacheeId: ['', Validators.required],
			}),
			{ debounceTime: 250 }
		);
		this._initObservables();
	}

	private _initObservables() {
		this.organizationsId$ = this._userApplicationPort.observeSessionUser().pipe(
			switchMap((user) =>
				combineLatest([user.organization$, user.partners$]).pipe(
					map(([organization, partners]) => ({
						organizations: [organization, ...partners],
						user,
					}))
				)
			),
			map((data) =>
				data.organizations.filter(
					(o) =>
						!o.isPropertyTrue(OrganizationPropertyName.IS_FICTITIOUS, false) &&
						data.user.hasRightOnOrganization(o.id, 'COACHEE', 'CAN_CREATE')
				)
			),
			map((organizations) => organizations.map((o) => o.id)),
			shareReplay({ refCount: true, bufferSize: 1 })
		);

		this.coacheesWithoutCoach$ = this.organizationsId$.pipe(
			switchMap((userOrganizationsId) =>
				this._userApplicationPort.observeCoacheesWithoutCoach(userOrganizationsId)
			),
			map((users) => users.data),
			tap((users) => this.form.patchValue({ coacheeId: users[0]?.id })),
			map((users) =>
				users.map((o) => ({ label: o.name, value: o.id } as SelectItem))
			),
			shareReplay({ refCount: true, bufferSize: 1 })
		);
	}
}
